import { IItem } from "./IItem";
import { AbstractItem } from "./AbstractItem";
import { IValueContainable } from "./IValueContainable";
import { IQuotable } from "./IQuotable";
import { RelationalActionParameter } from "./RelationalActionParameter";
import { instanceOfIPasteRequestable } from "./IPasteRequestable";
import { ObjectId } from "../ObjectId";
import { IRuleInjectable } from "./IRuleInjectable";
import { InjectedRule } from "./InjectedRule";

export abstract class AbstractValuedItem extends AbstractItem implements IValueContainable, IQuotable, IRuleInjectable {
  constructor(typeKey: string, value: any) {
    super(typeKey);
    this._value = this.cloneValue(value);
    this._originalValue = this.cloneValue(value);
  }

  public name: string = "";

  private _value: any = undefined;

  get value(): any {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
  }

  private readonly _originalValue: any = undefined;

  get originalValue(): any {
    return this._originalValue;
  }

  protected get shouldPasteOnUpdating(): boolean {
    return instanceOfIPasteRequestable(this)
        && (0 < this.pasteDestinations.length);
  }

  public shouldQuote: boolean = false;
  public supportedQuotable: boolean = true; // 名称がいまいちだが、isQuotableにするとバックエンド側のプロパティと紛らわしくなるのでそのままにしている
  public isQuoted: boolean = false;

  /**
   * 値に変更があった場合にExternalProcessを起動する機能のパラメータ
   */
  public scriptExecuteParameters: RelationalActionParameter[] = [];

  // 制約の注入
  public injectedRule: InjectedRule = null;

  protected applyMembers(clone: AbstractValuedItem): void {
    super.applyMembers(clone);
    clone.name = this.cloneValue(this.name);
    clone.value = this.cloneValue(this.value);
    clone.shouldQuote = this.cloneValue(this.shouldQuote);
    clone.supportedQuotable = this.cloneValue(this.supportedQuotable);
    clone.isQuoted = this.cloneValue(this.isQuoted);
    clone.scriptExecuteParameters = this.cloneValue(this.scriptExecuteParameters);
    clone.injectedRule = this.cloneValue(this.injectedRule);
  }

  handleItemUpdated(
    originalItem: IItem,
    updatedItem: IItem,
    isInSameSection: boolean,
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem[]
  ): IItem {
    return this.getUpdatedClone<AbstractValuedItem>(
      s => super.handleItemUpdated(originalItem, updatedItem, isInSameSection, itemAccessor, itemsAccessor) as AbstractValuedItem
    );
  }

  rollbackValue(): void {
    this.value = this.cloneValue(this.originalValue);
  }
}
